import { AuthServiceModule } from 'services/auth/auth.service';

export const CheckEmailDirectiveModule = angular
    .module('app.directives.checkEmail', [
        AuthServiceModule
    ])
    .directive('vlnCheckEmail', ($q, authService) => {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: (scope, element, attrs, ngModelCtrl) => {
                ngModelCtrl.$asyncValidators.emailAvailable = (modelValue, viewValue) => {
                    let email = modelValue || viewValue;
                    return authService.checkEmail(email).then((res) => {
                        if (res.data === true) {
                            //username exists, this means validation fails
                            return $q.reject('exists');
                        }
                        return true;
                    });
                };
            }
        };
    }).name;


// WEBPACK FOOTER //
// ./src/app/directives/checkEmail.directive.js